import uuid from "../../../library/uuid.js";

import ObjectHandle from "../ObjectHandle.js";

import Style from "../../utils/Style.js";

import Transform from "../Transform.js";

//const log = global.log.getLogger("f_mtac.scene.drivers.note");

const PA = 10; // padding (in px)
const LH = 1; // line height (in ex)
const LD = 0.8; // leading (in ex)
// const W = 32; // maximum width (in em)

let Note = function(group, color, text) {
    this.data = {
        id: `local-${uuid()}`,
        color: color,
        class: ["node", "note", "object", "movable", "removable"],
        text: ""
    };
    this.group = group;
    this.handle = null;
    this.node = null;

    this.note_rect = null;
    this.note_text = null;
    this.note_line = null;
    this.text = (text === undefined) ? null : text;

    this.width = 0;
    this.height = 0;

    this.position = {
        x: 0,
        y: 0
    };
};

Note.prototype.fit = function() {
    this.note_text.attr("x", 0).attr("y", PA);
    let {width, height, y} = this.note_text.node().getBBox();
    this.width = width;
    this.height = height;
    this.note_rect
        .attr("x", - this.width / 2).attr("y", - this.height / 2)
        .attr("width", this.width + 2 * PA)
        .attr("height", this.height + 2 * PA);
    this.note_text
        .attr("x", - this.width / 2).attr("y", - this.height / 2 + 2 * PA - y);
    this.note_text.selectAll("tspan").attr("x", - this.width / 2 + PA);    
    this.node.select(".object_handle")
        .attr("cx", - this.width / 2)
        .attr("cy", - this.height / 2);
    this.node.select(".object_handle_hit_box")
        .attr("cx", - this.width / 2)
        .attr("cy", - this.height / 2);
};

Note.prototype.write_text = function(text) {
    this.text = text;
    this.note_line = [];
    this.note_text.html("");
    for (let line of text) {
        let tspan = this.note_text.append("tspan").attr("x", PA).attr("dy", `${LH + LD}ex`).text(line);
        this.note_line.push(tspan);
    }
    this.fit();
};

Note.prototype.draw = function(x, y) {
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.node = this.handle.append("g")
        .attr("class", this.data.class.join(" "))
        .attr("transform", `translate(${x},${y})`);
    this.position.x = x;
    this.position.y = y;

    this.note_rect = this.node.append("rect")
        .attr("x", 0).attr("y", 0)
        .attr("width", this.width)
        .attr("height", this.height)
        .attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 1)
        .attr("fill", this.data.color).attr("fill-opacity", 0.8);

    this.note_text = this.node.append("text")
        .attr("x", 0).attr("y", PA);

    if (this.data.color === "#000") {
        this.note_text.style("fill", "#fff");
    } else {
        this.note_text.style("fill", "#000");
    }

    if (this.text !== null) {
        this.write_text(this.text);
    }
};

Note.prototype.update = function(x, y) {
    this.note.attr("transform", `translate(${x},${y})`);
};

Note.prototype.cancel = function() {
    this.note.remove();
};
Note.prototype.end = function() {
    let object_handle = ObjectHandle({
        x: - this.width / 2,
        y: - this.height / 2,
        color: this.data.color
    });
    this.node.append(() => object_handle.node());
    return Promise.resolve();
};
Note.prototype.is_empty = function() {
    return false;
};
Note.prototype.detach = function() {
    this.handle = null;
    this.node = null;
    this.note_rect = null;
    this.note_line = null;
    this.text = null;
};
Note.prototype.export = function() {
    return this.handle;
};

const style = new Style();

Note.import = (object) => {
    let note = new Note(null, null, null);
    note.handle = object.handle;
    note.node = object.node;
    note.note_rect = object.node.select("rect");
    note.note_text = object.node.select("text");
    note.text = object.node.selectAll("tspan").nodes().map(node => node.textContent);
    return note;
};

Note.transform = new Transform({k: 1});
Note.transform.on_scale(({k}) => {
    style.rule_set("scene_note_scale", `
        #notes g.object.note rect {
            transform: scale(calc(${1/k} * 3 / 2 * var(--kr)));
        }
        #notes g.object.note text {
            transform: scale(calc(${1/k} * 3 / 2 * var(--kr)));
            font-family: "Roboto Condensed";
            font-size: 1.8rem;
            font-weight: 300;
        }
        #notes g.object.note g {
            transform: scale(calc(${1/k} * 3 / 2 * var(--kr)));
        }
        #notes g.object.note .object_handle { r: calc(1 / 8 * 3 / 2 * 4 / 3 * var(--wb));}
        #notes g.object.note .object_handle_hit_box { r: calc(1 / 3 * 3 / 2 * 4 / 3 * var(--wb));}
    `);
});
export default Note;
